import { gql } from '@apollo/client';

const UPDATE_KEYCLOAK_USER_PREFERRED_LANGUAGE = gql`
    mutation UpdatePreferredLanguage($preferredLanguage: String!) {
        updatePreferredLanguage(preferredLanguage: $preferredLanguage)
    }
`;

export default UPDATE_KEYCLOAK_USER_PREFERRED_LANGUAGE;